import styled from "styled-components"
import { categoryIconSizeStyles } from "src/frontend/components/Shared/Layout/Components/Headers/categoryIconSizeStyles"
import { type ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"
import { EntityIcon } from "src/shared/components/ObjectEntities/EntityIcon"
import AssetsHelper, { CDNAsset } from "src/shared/helpers/assetsHelper"

/*
  STYLES
*/

const HeadCountLogo = styled(EntityIcon)<{ componentSize: ComponentSize }>`
  ${categoryIconSizeStyles};
  padding: 17px;
  border-radius: 50%;
`

const EllipsisText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

/*
  COMPONENTS
*/

export const VendorLogoTitle: React.FC<{
  title: string
  componentSize: ComponentSize
  iconObjectName?: string
}> = ({ title, componentSize, iconObjectName }) => (
  <span css="display: flex; align-items: center; gap: 4px;">
    <EllipsisText>{title}</EllipsisText>
    {iconObjectName && (
      <HeadCountLogo
        componentSize={componentSize}
        imageUrl={AssetsHelper.publicUrl(CDNAsset.PartyIcons, iconObjectName)}
      />
    )}
  </span>
)
